export const locales = {
  KK: 'kk',
  RU: 'ru',
  EN: 'en',
} as const;

type KeyOfLocale = keyof typeof locales;
export type Locale = (typeof locales)[KeyOfLocale];
